import { mapGetters, mapActions } from 'vuex'
import { isArray, isEmpty, trim, getByteLen } from '@/common/js/utils'
import { getSession } from '@/common/js/api'

// 公共组件
import Mixcheck from '@/components/mixcheck'
import CheckItem from '@/components/mixcheck/check-item'
import RadioItem from '@/components/mixcheck/radio-item'
import Moduler from '@/components/moduler'
import ErrorPop from '@/components/error-pop'
import InputLen from '@/components/input/input-len'
import InputNumberPlus from '@/components/input/input-number-plus'
import AutoComplete from '@/components/autocomplete/autocomplete'
import Affix from '@/components/affix.vue'

export default {
  components: {
    Mixcheck,
    CheckItem,
    RadioItem,
    Moduler,
    ErrorPop,
    InputLen,
    InputNumberPlus,
    AutoComplete,
    Affix
  },
  computed: {
    ...mapGetters('Baidulocal', ['subCurrent', 'subModules']),
    accounts() {
      return getSession('ad_account_ids') || []
    },
    adAccount() {
      const ad = this.accounts[0]
      if (ad) {
        const { id } = ad
        return id || this.account
      } else return this.account
    }
  },
  methods: {
    ...mapActions('Baidulocal', ['refreshDocTitle']),
    invalid(rules) {
      const arr = []
      const multRuleName = (name) => {
        const rule = name.split('/')
        if (rule.length > 3) return this[rule[0]][rule[1]][rule[2]][rule[3]]
        else if (rule.length > 2) return this[rule[0]][rule[1]][rule[2]]
        else return this[rule[0]][rule[1]]
      }
      if (!isArray(rules)) throw new Error('rule must be array')
      for (let i = 0; i < rules.length; i++) {
        let param
        let length
        const rule = rules[i]
        const ruleName = rule.name.indexOf('/') > -1 ? multRuleName(rule.name) : this[rule.name]
        if (typeof ruleName === 'undefined') continue
        if (typeof ruleName === 'string') {
          param = trim(ruleName)
          length = getByteLen(param)
        } else if (isArray(ruleName)) {
          param = ruleName
          length = param.length
        } else if (typeof ruleName === 'number') {
          param = length = ruleName
        } else {
          param = ruleName
          length = String(param).length
        }

        // 依赖
        if (rule.relyon) {
          const rely = rule.relyon.indexOf('/') > -1 ? multRuleName(rule.relyon) : this[rule.relyon]
          if (rely !== rule.relyvalue) continue
        }

        // 必填
        if ((rule.require && !param) || (rule.require && isEmpty(param))) {
          const msg = `${rule.desc}不能为空`
          this.formErr = true
          arr.push({ feild: rule.desc, msg: rule.msg || msg })
          continue
        }

        // 长度判断
        if (typeof param === 'string' || isArray(param)) {
          if (param && rule.max < length) {
            const msg = `${rule.desc}不能多于${rule.max}个字符`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
          if (param && rule.min > length) {
            const msg = `${rule.desc}不能少于${rule.min}个字符`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        } else if (typeof param === 'number') {
          // 大小判断
          if (rule.max < length) {
            const msg = `${rule.desc}数值不能大于${rule.max}`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
          if (rule.min > length) {
            const msg = `${rule.desc}数值不能小于${rule.min}`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }

        // 正则
        if (rule.pattern) {
          const reg = new RegExp(rule.pattern, 'g')
          if (!reg.test(param)) {
            const msg = `${rule.desc}不是有效的值`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }
      }
      return arr
    },
    inputTrim(key, val, obj, fixed) {
      if (isEmpty(val)) return val
      val = trim(val)
      if (fixed) {
        val = parseFloat(val) * 100
        val = Math.floor(val) / 100
      } else val = parseInt(val)
      obj[key] = isEmpty(val) ? 0 : val
    },
    beforeHandler() {
      window.onbeforeunload = function (event) {
        const msg = '您正在编辑内容，离开数据将丢失，确定要退出本页吗？'
        event.returnValue = msg
        return msg
      }
    },
    toTop() {
      const contentElem = window.document.querySelector('.ivu-layout-content')
      contentElem.scrollTop = 0
      contentElem.addEventListener('scroll', this.handleScroll)
    },
    handleScroll(e) {
      this.$store.commit('Baidulocal/setScroll', e.target.scrollTop)
    }
  },
  data() {
    return {
      loading: null,
      saving: null,
      formErr: null,
      errRes: [],
      account: getSession('ad_account_ids') ? getSession('ad_account_ids')[0].id : this.$store.state.Baidulocal.accountId,
      media: Number(this.$store.state.Baidulocal.media),
      opId: Number(this.$store.state.Baidulocal.account)
    }
  },
  mounted() {
    this.$nextTick(() => {
      // this.beforeHandler()
      this.toTop()
      this.refreshDocTitle()
    })
  },
  beforeDestroy() {
    const contentElem = window.document.querySelector('.module-content')
    contentElem.removeEventListener('scroll', this.handleScroll)
  }
}
